module.exports = __webpack_public_path__ + "static/media/icone-filial.df33467e.png";